import React from 'react';

const BackToTop = () =>{
    return(<a href="javascript:" id="return-to-top" style={{display: 'block'}}><i className="fas fa-arrow-up" /></a>);
};

export default BackToTop;